import React from "react";
// import thư viện
import { Heart, ShoppingBag, User } from "lucide-react";
import classNames from "classnames/bind";
import { useNavigate } from "react-router-dom";
// import file style
import styles from "./ActionIcons.module.scss";
import LanguageSelector from "../LanguageSelector/LanguageSelector.js";
import SearchBar from "../SearchBar/SearchBar.js";

// import store manage state
import { useCartSidebarStore } from "../../stores/Cart/cartSidebarStore.js";
import { useOpenCloseAuthModalStore } from "../../stores/Auth/useAuthModal.js";
import { useFavoritesModalStore } from "../../stores/WishList/useFavoritesModal.js";
import useAuthStore from "../../stores/Auth/AuthStore.js";



const cx = classNames.bind(styles);

const ActionIcons = ({ className, searchPlaceholder }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const toggle = useCartSidebarStore((state) => state.toggle)
  const toggleAuthModal = useOpenCloseAuthModalStore((state) => state.toggleAuthModal)
  const toggleFavoritesModal = useFavoritesModalStore((state) => state.toggleFavoritesModal)


  const handleUserIconClick = () => {
    if (isAuthenticated) {
      navigate('/profile');
    } else {
      toggleAuthModal();
    }
  };

  return (
    <div className={cx("icons", className)}>

      <SearchBar searchPlaceholder={searchPlaceholder}
      />
      <button className={cx("icons__button")} onClick={toggleFavoritesModal}>
        <Heart size={20} />
      </button>
      <button className={cx("icons__button")} onClick={toggle}>
        <ShoppingBag size={20} />
      </button>
      <button className={cx("icons__button")} onClick={handleUserIconClick}>
        <User size={20} />
      </button>
      <LanguageSelector />
    </div>
  );
};

export default ActionIcons;
